/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useEffect, useState, useContext
} from 'react';
import _ from 'lodash';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import appConfig from 'app-config';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLLocalDateUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useModal } from '@jutro/components';
import { QuestionSetComponent, platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLMultiLobsDataHolderService, MLBundleService } from 'ml-services-common-react';
import {
    PriorInsuranceComponent,
    DriversListComponent,
    DriversTableActionComponent,
    VehiclesListComponent,
    AddExcludedDriverPopup,
    AddHouseholdMemberPopup,
    PriorMetSubmissionPopup,
    PriorMetSubmissionPopupMessages,
    PriorMetSubmissionPopupStyles
} from 'ml-capability-quoteandbind-common-react';

import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';

import { UserService } from 'gw-capability-gateway';
import { withRouter } from 'react-router-dom';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import metadata from './AdditionalInformationPage.metadata.json5';
import messages from './AdditionalInformation.messages';
import { commonMessages } from 'gw-capability-quoteandbind-common-react';
import { MVR_ERR1,MVR_ERR2,MVR_ERR3 } from '../../../../override/constants/ml-mvr-constants';

const isGPA = appConfig.portalCode === 'GPA';
const isQnB = appConfig.portalCode === 'QB';
const PA_MODEL_PATH = 'lobData.personalAuto.coverables.value';
const PA_MODIFIER_PATH = 'lobData.personalAuto.modifiers_ML';
const PRIMARY_VEHICLE_REQ_STATE_PATH = 'baseData.isDriverPrimaryVehicleRequiredState_Ext.value';
const STATE_PATH = 'baseData.policyAddress.state.value.code';
const HALF_DRIVER = 50;
const MIN_DATE = { year: 1900, month: 0, day: 1 };
const MAX_DATE = { year: 2100, month: 0, day: 1 };
const accidentPreventionCode = ['PADriversRoleModiferPreventionCourse_ML', 'PADriverAccidentPrevention_ML'];
const residentStudentCode = 'PADriverResidentStudent_ML';
const educationQuestionId = 'z0ujoks5u2rcm9ioeoaqrcfgrh9';
const WLBForSeniorsCode = 'PAWorkLossBenefitsForSeniors_Ext';
const multipolicyLobCodes = ['PAMultiplePolicyHomePolicyNumber_ML', 'PAMultiplePolicyRentersPolicyNumber_ML', 'PAMultiplePolicyCondoPolicyNumber_ML', 'PAMultiplePolicyMobilePolicyNumber_ML',
    'PAMultiplePolicyLandlordPolicyNumber_ML', 'PAMultiplePolicyLandlordCondoPolicyNumber_ML', 'PAMultiplePolicyBoatPolicyNumber_ML', 'PAMultiplePolicyUmbrellaPolicyNumber_ML',
    'PAMulitplePolicyMotorCyclePolicyNumber_Ext', 'PAMulitplePolicyRecreationalVehPolicyNumber_Ext', 'PAMulitplePolicyOffRoadVehPolicyNumber_Ext']

const requiredQuestionSets_ML = ["CompanyPolicyNumber_Ext", "TenureOriginalEffDate_Ext", "FarmersSubCompany_Ext"]

const AdditionalInformation = (props) => {
    const modalApi = useModal();
    const modalErrorApi = useModal();
    const {
        wizardData: submissionVM, updateWizardData, steps, goNext, jumpTo, isFieldDefaultedByHVQ, updateWizardSnapshot, isSkipping, history, currentStep
    } = props;

    const {
        onValidate, isComponentValid, registerComponentValidation, initialValidation
    } = useValidation('AdditionalInfoPage');

    const { nextStepVisited, canShowReturnToQuoteButton } = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        getHouseholdDriverType,
        getExcludedDriverType,
        isVehicleEligibleForAccidentPrevention,
        getRatedDriversNonStudent,
        validateVehiclesHaveAssignmentsForEveryDriver,
        validateVehicleAssignmentPercentages,
        displayNonAPModifierLAMessage,
        isDriverHousehold
    } = MLDriverVehicleUtil();

    const {
        addErrorAlert,
        clearBlockAlerts,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    const { refreshData } = useDataRefresh();

    const DRIVERTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const VEH_DRV_ERR = _.get(submissionVM, STATE_PATH) === 'LA' ? translator(messages.vehiclePercentageDriverError) : translator(messages.vehiclePrimaryDriverError);
    const TOTAL_PCT_ERROR = translator(messages.totalPercentageError);
    const ASSIGNMENT_REQ_ERR = translator(messages.assignmentRequiredError);

    const newPolicyReasonHelpTextMap = translator(messages.helptextMap)
    const newPolicyReasonHelpTextTitleMap = translator(messages.helptext)

    const isVehiclePrimaryDriverState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverState_Ext.value');
    const isVehiclePrimaryDriverPercentageState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverPercentageState_Ext.value');
    const vehicleDriversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicleDrivers_Ext');
    const questionSets = submissionVM.lobData.personalAuto.questionSets_ML.value;
    const quoteID = submissionVM.quoteID.value;
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH);
    const isPrimaryVehicleReqState = _.get(submissionVM, PRIMARY_VEHICLE_REQ_STATE_PATH);
    const state = _.get(submissionVM, STATE_PATH);
    const canExcludeDrivers = _.get(submissionVM, 'baseData.canExcludeDrivers_ML.value', true);

    const paModel = _.get(submissionVM, PA_MODEL_PATH);
    const { vehicles } = paModel;
    const [drivers, setDrivers] = useState(paModel.drivers);
    const ratedDrivers = drivers.filter((driver) => driver.type_ML === DRIVERTYPE_TYPELIST.getCode('rated').code);
    const [nonAccidentPreventionDisplayed, setNonAccidentPreventionDisplayed] = useState(false);
    const [priorInsuranceErrors, setPriorInsuranceErrors] = useState([]);
    const [showAdditionInfoErrors, setShowAdditionInfoErrors] = useState(false);
    const [vehicleDriverErrors, setVehicleDriverErrors] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const [showPriorInsuranceErrors, setShowPriorInsuranceErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const [canRequote, setCanRequote] = useState(false);
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const [excludedDrivers, setExcludedDrivers] = useState(drivers.filter((driver) => {
        return driver.type_ML === getExcludedDriverType();
    }));
    const [houseHoldDrivers, setHouseHoldDrivers] = useState(drivers.filter((driver) => {
        return isDriverHousehold(driver);
    }));
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    let returnToQuoteClicked = false;

    if (paModifiers && paModifiers.lineModifiers.value) {
        paModifiers.lineModifiers.value.forEach(
            (mod) => {
                mod.savedFromPortal = true;
                mod.updated = true;
                mod.editMode_ML = true;

                if (multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                    mod.isVisible_ML = false
                    mod.isInputValueRequired_ML = false
                    mod.editMode_ML = false
                    mod.savedFromPortal = false
                } else {
                    mod.isVisible_ML = true
                }
            }
        );
    }

    const [hasError, setHasError] = useState(false);
    const isModifierTypeTypeKeyAsText = (mod) => mod.valueType.value === 'TypeKeyAsText';
    const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
    const BOOKROLL_QUOTE_ASSIST = "quote_assist" 
    const BOOKROLLTYPE_QUOTE_ASSIST = "quote_assist"
    const BOOKROLLTYPE_CAREER_BOOK_TRANSFER = 'carrier_book_transfer';
    const BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL = 'independent_agent_book_roll';
    const invalidBookRollTypeCombination = ['CurrentInsuranceProviderNoPriorInsurance_Ext', 'CurrentInsuranceProviderFarmers_ML', 'CurrentInsuranceProviderInnocentNoPriorMilitary_Ext', 'CurrentInsuranceProviderInnocentNoPriorAllOther_Ext',
        'CurrentInsuranceProviderInnocentNoPriorFirstCar_Ext', 'CurrentInsuranceProviderInnocentNoPriorInStorage_Ext'];

    const getVehicleEligbleAsPrimaryVehicles = useCallback(() => {
        return vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh))
    }, [isVehicleEligibleForAccidentPrevention, vehicles])

    const setVehicleAssignmentsToSingleDriver = useCallback((driver) => {
        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles()
        vehicleDriversVM.value = [];
        eligibleVehicles.forEach((veh) => {
            const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
            vehicleDriver.vehicleID.value = veh.fixedId;
            vehicleDriver.driverID.value = driver.fixedId;
            vehicleDriver.percentageDriven_Ext.value = 100;
            vehicleDriversVM.pushElement(vehicleDriver.value);
        });
    }, [getVehicleEligbleAsPrimaryVehicles, vehicleDriversVM, viewModelService]);

    const checkForInvalidBookrollCombination = () => {
        clearBlockAlerts('InvalidInsuranceProviderForBookRoll');
        const insurerAnswer = _.get(questionSets, "priorInsurance.answers.CurrentInsuranceProvider_ML");
        const isBookRoll = _.get(submissionVM, 'bookrollInd_ML.value.code');
        const bookRollType = _.get(submissionVM, 'bookRollType_Ext.value.code');
        const InsuredPolicyLast90Days = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.answers.value.InsuredPolicyLast90Days_ML')
        if((isBookRoll !== undefined && isBookRoll !== null && (isBookRoll === BOOKROLL_WITHOUT_RATE_CAPPING || isBookRoll === BOOKROLL_QUOTE_ASSIST))
                && (bookRollType !== undefined && bookRollType !== null 
                && (bookRollType === BOOKROLLTYPE_CAREER_BOOK_TRANSFER || bookRollType === BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL || bookRollType === BOOKROLLTYPE_QUOTE_ASSIST))
                && (invalidBookRollTypeCombination.includes(insurerAnswer) 
            || (InsuredPolicyLast90Days !== undefined && InsuredPolicyLast90Days !== null && InsuredPolicyLast90Days === 'true'))){
                return true;
            }
        return false;
    }

    const prefillBundleInfoPAData = () => {
        const prefillFrom = MLBundleService.getPrefillCandidateForJobType(quoteID, 'PA');
        if (prefillFrom) {
            const questionSet = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value');
            questionSet.answers[educationQuestionId] = questionSet.answers[educationQuestionId] || prefillFrom.education;
        }
    };

    const setCanRequoteFlag = useCallback(async () => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    const openErrorModal = useCallback(() => {
        const componentProps = {
            CustomComponent: () => <div>{translator(messages.somethingWentWrong)}</div>,
            actionBtnLabel: translator(commonMessages.close),
            showHeader: false,
            showFooterOnCustomComponent: true,
            showActionButton: true
        };

        modalErrorApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [modalErrorApi, translator]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Additional Information Page' });
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []);

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    useEffect(() => {
        if (ratedDrivers.length === 1 && (isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)) {
            setVehicleAssignmentsToSingleDriver(ratedDrivers[0]);
        }

        if (submissionVM.isBundle_ML.value) {
            prefillBundleInfoPAData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const element = document.getElementById("priorInsuranceHeader");
            if (element) {
                element.focus();
            }
        }, 100)
    }, []);

    const addressVM = _.get(submissionVM, 'baseData.policyAddress');
    const shouldShowVehicleListSection = useCallback(() => {
        let primaryDriverRequired = false;
        if ((isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)
            && drivers.length > 1) {
            drivers.forEach((driver) => {
                _.get(driver, 'driverModifiers_ML.modifiers', []).forEach((modifier) => {
                    if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                        if (modifier.chosenTermValue === 'true') primaryDriverRequired = true;
                    }
                });
            });
        }
        if (paModifiers && paModifiers.lineModifiers.value) {
            paModifiers.lineModifiers.value.forEach((modifier) => {
                if (WLBForSeniorsCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                    if ((modifier.chosenTermValue === 'true') && (addressVM.state.value && addressVM.state.value.code === 'MN')) primaryDriverRequired = true;
                }
            }
            );
        }
        return primaryDriverRequired;
    }, [addressVM.state.value, drivers, isVehiclePrimaryDriverPercentageState, isVehiclePrimaryDriverState, paModifiers]);

    const onUpdateErrors = useCallback((val) => {
        setPriorInsuranceErrors(val);
    }, []);

    const onUpdateDrivers = useCallback((val) => {
        setDrivers(val);
    }, []);

    const hasMissingRequiredDriverAssignment = useCallback(() => {
        let hasMissing = false;
        const hasAssignmentAlert = getNumberOfAlerts('assignmentRequiredError') > 0;
        if (vehicleDriversVM.value.some((vd) => vd.driverID === null || vd.driverID === 0)) {
            if (!hasAssignmentAlert) {
                addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
            }
            window.scrollTo(0, 0);
            hasMissing = true;
        } else {
            clearBlockAlerts('assignmentRequiredError')
        }
        return hasMissing;
    }, [ASSIGNMENT_REQ_ERR, addErrorAlert, clearBlockAlerts, getNumberOfAlerts, vehicleDriversVM.value]);

    const getPrimaryDriverList = useCallback((eligibleVehicles) => {
        const primaryDriverList = [];
        eligibleVehicles.forEach((el) => {
            const tmp = vehicleDriversVM.filter((vd) => vd.vehicleID && vd.vehicleID.value === el.fixedId);
            if (tmp !== undefined) {
                const r = Math.max(...tmp.map((ar) => ar.percentageDriven_Ext.value));
                primaryDriverList.push(tmp.find((t) => parseInt(t.percentageDriven_Ext.value, 10) === r).driverID.value);
            }
        });
        return primaryDriverList;
    }, [vehicleDriversVM]);

    const primaryDriversError = useCallback(() => {
        let hasPrimaryDriversError = false;

        clearBlockAlerts('vehicleDriverError')

        if (hasMissingRequiredDriverAssignment()) {
            return true;
        }

        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles()
        const primaryDriverList = getPrimaryDriverList(eligibleVehicles);
        if (eligibleVehicles.length >= ratedDrivers.length) {
            const residentStudent = [];
            ratedDrivers.forEach((ratedDriver) => {
                if (ratedDriver.driverModifiers_ML?.modifiers) {
                    ratedDriver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.codeIdentifier_ML === residentStudentCode && modifier.chosenTermValue === 'true') {
                            residentStudent.push(ratedDriver);
                        }
                    });
                }
            });
            const resStudentArr = [];
            residentStudent.forEach((res) => {
                resStudentArr.push(res.fixedId);
            });
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });

            ratedDrivers.forEach((el) => {
                if (!resStudentArr.includes(el.fixedId) && !primaryDriverList.includes(el.fixedId)) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });
        } else {
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });
            if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                if (!hasPrimaryDriversError) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                    hasPrimaryDriversError = true;
                }
            }
        }
        if (hasPrimaryDriversError) {
            window.scrollTo(0, 0);
        }
        return hasPrimaryDriversError;
    }, [VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getPrimaryDriverList, getVehicleEligbleAsPrimaryVehicles, hasMissingRequiredDriverAssignment, ratedDrivers, vehicleDriversVM.value]);

    const areVehiclePrimaryDriverAssignmentPercentagesInvalid = useCallback(() => {
        let areAssignmentsInvalid = false;
        const primaryDriverList = [];
        clearBlockAlerts('vehicleDriverError')
        clearBlockAlerts('assignmentRequiredError')
        clearBlockAlerts('totalPctError')

        vehicleDriversVM.value.forEach((vd) => {
            if (!vd.percentageDriven_Ext) {
                vd.percentageDriven_Ext = 0;
            }
        });

        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles();
        const ratedDriversNonStudent = getRatedDriversNonStudent(ratedDrivers);
        if (eligibleVehicles.length > 0) {
            if (!validateVehiclesHaveAssignmentsForEveryDriver(eligibleVehicles, ratedDrivers, vehicleDriversVM)) {
                addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
                areAssignmentsInvalid = true;
            }

            if (!validateVehicleAssignmentPercentages(eligibleVehicles, vehicleDriversVM)) {
                addErrorAlert(TOTAL_PCT_ERROR, 'totalPctError');
                areAssignmentsInvalid = true;
            }

            // capture primary drivers for all eligible vehicles
            let multiplePrimaryDrivers = false;
            eligibleVehicles.forEach((vehicle) => {
                const vehicleAssignments = vehicleDriversVM.value.filter((vd) => vd.vehicleID === vehicle.fixedId);
                if (vehicleAssignments.length > 0) {
                    const max = Number(Math.max(...vehicleAssignments.map((ar) => ar.percentageDriven_Ext)));
                    if (vehicleAssignments.filter((va) => va.percentageDriven_Ext === max).length > 1) {
                        multiplePrimaryDrivers = true;
                    }
                    primaryDriverList.push(vehicleAssignments.find((t) => parseInt(t.percentageDriven_Ext, 10) === max).driverID);
                }
            });

            if (multiplePrimaryDrivers) {
                addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                areAssignmentsInvalid = true;
            } else if (ratedDriversNonStudent.length >= eligibleVehicles.length) {
                // check that driver isn't primary on more than one vehicle
                if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                    areAssignmentsInvalid = true;
                }
            } else {
                // check that each rated driver is primary on at least one vehicle
                ratedDriversNonStudent.forEach((driver) => {
                    if (!primaryDriverList.includes(driver.fixedId)) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        areAssignmentsInvalid = true;
                    }
                });
            }
        } else if (vehicleDriversVM.length > 0) {
            vehicleDriversVM.value = [];
        }
        return areAssignmentsInvalid;
    }, [ASSIGNMENT_REQ_ERR, TOTAL_PCT_ERROR, VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getRatedDriversNonStudent, getVehicleEligbleAsPrimaryVehicles, ratedDrivers, validateVehicleAssignmentPercentages, validateVehiclesHaveAssignmentsForEveryDriver, vehicleDriversVM]);


    const validateVehicleDrivers = useCallback(() => {
        if (shouldShowVehicleListSection()) {
            if (isVehiclePrimaryDriverState) {
                return !primaryDriversError();
            }

            if (isVehiclePrimaryDriverPercentageState) {
                return !areVehiclePrimaryDriverAssignmentPercentagesInvalid();
            }
        }
        return true;
    }, [areVehiclePrimaryDriverAssignmentPercentagesInvalid, isVehiclePrimaryDriverPercentageState, isVehiclePrimaryDriverState, primaryDriversError, shouldShowVehicleListSection]);

    const questionSetsAspects = submissionVM.lobData.personalAuto.questionSets_ML.aspects;
    const validateQuestionSets = useCallback(() => {
        if (!_.isEmpty(questionSetsAspects) && (!questionSetsAspects.valid
            || !questionSetsAspects.subtreeValid)) {
            return false;
        }
        return true;
    }, [questionSetsAspects]);

    const performPageValidation = useCallback(() => {
        return validateQuestionSets() && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && !hasError;
    }, [hasError, submissionVM.aspects.subtreeValid, submissionVM.aspects.valid, validateQuestionSets]);

    useEffect(() => {
        registerComponentValidation(performPageValidation);
    }, [performPageValidation, registerComponentValidation]);

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;
        if (questionSetSyncing && questionSetSyncPromise) {
            console.log("Waiting for questionSetSyncing to finish...")
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);
                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 100);
        }
        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);
        return updatePromise;
    };

      const validateAdditionInfoQuestions = useCallback((newVm = submissionVM) => {
        let flag = false

        // To Clear only required question set errors
        clearBlockAlerts('additionInfoQuestions');
        
        if (showAdditionInfoErrors) {
            setShowAdditionInfoErrors(false);
        }
    
        const preQualificationQuestions = _.get(newVm.value, 'lobData.personalAuto.questionSets_ML.preQualification', {});
        const priorInsuranceQuestions = _.get(newVm.value, 'lobData.personalAuto.questionSets_ML.priorInsurance', {});
        const houseAdditionalInformationQuestions = _.get(newVm.value, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation', {});
        const questionSet = { ...preQualificationQuestions.answers, ...priorInsuranceQuestions.answers, ...houseAdditionalInformationQuestions.answers }

        requiredQuestionSets_ML.forEach((item) => {
            const requiredQuestion = Object.entries(questionSet).find(([key, value]) => key === item);

            if (requiredQuestion && !_.isEmpty(requiredQuestion)) {
                if ((_.isNil(requiredQuestion[1]) ||
                    _.isEmpty(requiredQuestion[1]))) {
                    addErrorAlert(translator(messages[item]), 'additionInfoQuestions');
                    flag = true;
                    setShowAdditionInfoErrors(true);
                }
            }
        });
        
        return flag

    }, [addErrorAlert, clearBlockAlerts, showAdditionInfoErrors, submissionVM, translator]);

    const syncQuestionSets = useCallback((aQuestionSetAnswersValue) => {
        const { code } = aQuestionSetAnswersValue;

        if(checkForInvalidBookrollCombination()){
            const message = translator(messages.InvalidInsuranceProviderForBookRoll);
            addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
            window.scrollTo(0, 0);
        }

        if (code && code === "PAHouseAdditionalInformation_ML") {

            const newVm = viewModelService.clone(submissionVM);

            _.set(newVm, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', aQuestionSetAnswersValue);
            updateWizardData(newVm);
        } else {
            const syncPromise = checkQuestionSetSync(() => LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue], authHeader));

            syncPromise.then((updatedQuestions) => {
                const newVm = viewModelService.clone(submissionVM);
                const transformedQuestions = {};

                updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });

                if (code === "PAPersonalAutoPreQual") {
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.preQualification.value', transformedQuestions.PAPersonalAutoPreQual);
                } else if (code === "PAPriorInsurance_ML") {
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.priorInsurance.value', transformedQuestions.PAPriorInsurance_ML);
                } else {
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', transformedQuestions.PAHouseAdditionalInformation_ML);
                }

                updateWizardData(newVm);

                if (showAdditionInfoErrors) {
                    validateAdditionInfoQuestions(newVm);
                }
                
            }).finally(() => {
                setQuestionSetSyncPromise(null);
                setQuestionSetSyncing(false);
            });
        }
    }, [viewModelService, submissionVM, updateWizardData, checkQuestionSetSync, LoadSaveService, quoteID, authHeader, showAdditionInfoErrors, validateAdditionInfoQuestions]);

    const clearErrorMessages = useCallback(() => {
        drivers.forEach((driver) => {
            if (driver.error) {
                // eslint-disable-next-line no-useless-return
                return;
            }
        });
        setHasError(false);
    }, [drivers]);

    const addErrorMessage = useCallback(() => {
        addErrorAlert(messages.driverError, 'vehicleDriverError');
    }, [addErrorAlert]);

    const validateNonRatedDrivers = useCallback(() => {
        const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        setHasError(driversVM.some((driverVM) => {
            return !driverVM.aspects.valid || !driverVM.aspects.subtreeValid;
        }));
        if (hasError) {
            addErrorMessage();
        }
    }, [addErrorMessage, hasError, submissionVM]);

    const checkOwnsResidenceModifier = (mod, copiedView) => {
        if (mod.patternCode.value === 'z70hmvhmucbde2eo899j9kmgjdb') {
            if (mod.chosenTermValue.value) {
                if (!copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence) {
                    copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
                }
            }
        }
    };

    useEffect(() => {
        clearBlockAlerts('priorInsuranceErrors');
        if (showPriorInsuranceErrors === true) {
            priorInsuranceErrors.forEach((error) => {
                addErrorAlert(error, 'priorInsuranceErrors');
                window.scrollTo(0, 0);
            });
        }
    }, [showPriorInsuranceErrors])

    const syncModifiers = (submissionData, mlModifier) => {
        submissionData.forEach((mod) => {
            const oldMod = mlModifier.value.find((value) => {
                return value.patternCode === mod.patternCode;
            });
            _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : null);
            if (mod.valueType === 'boolean') {
                _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : false);
            }
            if (!multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                _.set(mod, 'savedFromPortal', true);
                _.set(mod, 'editMode_ML', true);
            }
        });
        _.set(mlModifier, 'value', submissionData);
    };

    const syncModifierDependentQuestions = (submissionData, mlModifier) => {
        if (mlModifier.yearsAtCurrentResidence) {
            mlModifier.yearsAtCurrentResidence.value = submissionData.yearsAtCurrentResidence;
        }
    };

    const updateModifier = async (mod) => {

        _.set(mod, 'updated.value', true);
        const validMods = [];
        const copiedModel = viewModelService.clone(submissionVM);

        for (let i = 0; i < paModifiers.lineModifiers.length; i += 1) {
            const modifier = paModifiers.lineModifiers.children[i];
            checkOwnsResidenceModifier(modifier, copiedModel);
            if (modifier.aspects.subtreeValid) {
                validMods.push(modifier.value);
            }
        }

        _.set(copiedModel, 'lobData.personalAuto.modifiers_ML.lineModifiers', validMods);

        try {
            const submissionData = await checkQuestionSetSync(() => LoadSaveService.updateModifiers(copiedModel.value, authHeader));

            syncModifiers(submissionData.lobData.personalAuto.modifiers_ML.lineModifiers, paModifiers.lineModifiers);
            syncModifierDependentQuestions(submissionData.lobData.personalAuto.modifiers_ML, paModifiers);
            updateWizardData(submissionVM);
        } catch (error) {
            if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                showErrorModal(null, messages.somethingWentWrong);
            }
        }
    };

    const isAccidentPreventionCourse = useCallback(() => {
        let nonAcciPrevModifier = false;
        if (isVehiclePrimaryDriverPercentageState) {
            drivers.forEach((driver) => {
                if (driver.driverModifiers_ML?.modifiers) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                            if (modifier.chosenTermValue === 'false') nonAcciPrevModifier = true;
                        }
                    });
                }
            });
        }
        return nonAcciPrevModifier;
    }, [drivers, isVehiclePrimaryDriverPercentageState]);

    const priorInsuranceExpirationDateValid = useCallback(() => {
        const currentExpDate = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value.answers.CurrentExpirationDate_ML');
        if (currentExpDate) {
            const localDate = MLLocalDateUtil.parseLocalDateString2LocalDate(currentExpDate);
            const toDate = MLLocalDateUtil.localDate2Date(localDate);
            const minDate = new Date(MIN_DATE.year, MIN_DATE.month, MIN_DATE.day);
            const maxDate = new Date(MAX_DATE.year, MAX_DATE.month, MAX_DATE.day);

            return toDate >= minDate && toDate <= maxDate;
        }
        return true;
    }, [submissionVM]);

    const setAnswerToRequiredQuestionToQuote = useCallback(() => {
        const questions = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value');
        if (questions) {
            questions.answers.zhkic2ei4bh312q198bis47oo3b = 'CurrentLiabilityLimitsBetweenStateMinimumAnd100/300_ML';
        }
    }, [submissionVM]);

    const showPriorInsuranceMetOrFarmers = useCallback(() => {
        const answers = _.get(questionSets, "priorInsurance.answers.CurrentInsuranceProvider_ML")
        return (answers === 'CurrentInsuranceProviderFarmers_ML' || answers === 'CurrentInsuranceProviderMetLifePropertyCasualty_ML')
    }, [questionSets]);

    const showPriorMetSubmissionModal = useCallback(() => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const onSaveAction = async (baseDataVM) => {
            showProgressDialog(platformMessages.saveSubmission);
            try {
                const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM?.value, authHeader);
                _.set(submissionVM, 'value', submissionData);
                updateWizardData(submissionVM);
                hideProgressDialog();
                goNext();
                return true;
            } catch (error) {
                if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    hideProgressDialog();
                    setTimeout(openErrorModal, 0);
                    return false;
                }
            }
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value'),
                controlClassName: isQnB ? 'radioButtonQnB' : '',
            }
        };

        const componentProps = {
            title: translator(PriorMetSubmissionPopupMessages.priorMetPopupHeader),
            uiProps: PriorMetSubmissionPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: PriorMetSubmissionPopupStyles,
            overrideProps: overrides,
            onSaveAction: onSaveAction,
            showXCloseButton: false
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [goNext, modalApi, newPolicyReasonHelpTextMap, newPolicyReasonHelpTextTitleMap, submissionVM, translator]);

    const updateDraftSubmissionOnRequote = useCallback(async (subVM) => {
        showProgressDialog(platformMessages.saveSubmission);
        try {
            const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(subVM.value, authHeader);
            _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
            const res = await checkQuestionSetSync(() => LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader));
            submissionVM.value = res;
        } finally {
            hideProgressDialog(platformMessages.saveSubmission);
            return submissionVM;
        }
    }, [LoadSaveService, authHeader, checkQuestionSetSync, hideProgressDialog, paModifiers.lineModifiers, showProgressDialog, submissionVM]);

  
    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'paAddtlInfoToQuote');

        if (!(isComponentValid && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            setShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        if (!validateVehicleDrivers()) {
            return false;
        }

        if (validateAdditionInfoQuestions()) {
            return false
        }

        if (!priorInsuranceExpirationDateValid()) {
            setShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        if (priorInsuranceErrors.length !== 0) {
            setTimeout(() => {
                window.scrollTo(0, 0);
                setShowPriorInsuranceErrors(true);
            }, 500);
            return false;
        }

        if (isAccidentPreventionCourse() && shouldShowVehicleListSection() && !nonAccidentPreventionDisplayed) {
            displayNonAPModifierLAMessage();
            setNonAccidentPreventionDisplayed(true);
            return false;
        }

        if (paModel.hasNamedNonOwner()) {
            setAnswerToRequiredQuestionToQuote();
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        if(checkForInvalidBookrollCombination()){
            const message = translator(messages.InvalidInsuranceProviderForBookRoll);
            addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
            window.scrollTo(0, 0);
            return false;
        }

        return true;
    }, [authHeader, currentStep.mlStepName, validateAdditionInfoQuestions, displayNonAPModifierLAMessage, errorTimestamp, isAccidentPreventionCourse, isComponentValid, nonAccidentPreventionDisplayed, paModel, priorInsuranceErrors.length, setAnswerToRequiredQuestionToQuote, shouldShowVehicleListSection, submissionVM, validateVehicleDrivers]);

    const onNext = useCallback(async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Additional Information Page', action: 'Additional Information Submitted' });
            });
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        _.set(submissionVM, 'portalCurrentStep_ML.value', 'paAddtlInfoToQuote');

        const canSkipSave = steps.some((step) => step.mlStepName === 'paDisclosureToQuote' && !!step.visited);

        if (canSkipSave && !returnToQuoteClicked) {
            MLMultiLobsDataHolderService.storeFlowSteps('paAddtlInfoToQuote', 'paDisclosureToQuote', authHeader);
            goNext();
        } else {
            showProgressDialog(platformMessages.saveSubmission);

            try {
                const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);

                _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);

                const res = await checkQuestionSetSync(() => LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader));

                if (res?.lobData) {
                    submissionVM.value = res;
                    _.set(submissionVM, 'value', res);
                }
                
                updateWizardData(submissionVM);

                if (!returnToQuoteClicked) {
                    MLMultiLobsDataHolderService.storeFlowSteps('paAddtlInfoToQuote', 'paDisclosureToQuote', authHeader);

                    if (showPriorInsuranceMetOrFarmers()) {
                        hideProgressDialog();
                        showPriorMetSubmissionModal();
                    } else {
                        if (!nextStepVisited()) {
                            return submissionVM;
                        }

                        updateWizardSnapshot(submissionVM);
                        goNext();
                    }
                } else {
                    const zip = _.get(submissionVM, 'baseData.policyAddress.postalCode.value').substring(0, 5);

                    history.push('/quoteentry', { quoteID: submissionVM.quoteID.value, postalCode: zip, returnToQuoteFlag: 'true' });
                }
            } catch (error) {
                if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    hideProgressDialog();
                    showErrorModal(null, messages.somethingWentWrong)

                    return false;
                }  
                
                if (error.baseError && error.baseError.includes(messages.mvrDMVError.defaultMessage)) {
                    hideProgressDialog();
                    showErrorModal(null, messages.mvrDMVError);

                    return false;
                } 

                if (error.baseError && (error.baseError.includes(MVR_ERR1) || error.baseError.includes(MVR_ERR2) || error.baseError.includes(MVR_ERR3))) {
                    hideProgressDialog();
                    showErrorModal(null, messages.mvrUnavailableError);

                    return false;
                }

                throw error;
            } finally {
                hideProgressDialog(platformMessages.saveSubmission);
            }
        }

        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComponentValid, submissionVM, validateVehicleDrivers, priorInsuranceErrors, isAccidentPreventionCourse, shouldShowVehicleListSection, nonAccidentPreventionDisplayed, paModel, LoadSaveService, authHeader, showProgressDialog, displayNonAPModifierLAMessage, setAnswerToRequiredQuestionToQuote, showPriorInsuranceMetOrFarmers, showPriorMetSubmissionModal, goNext]);

    const onReturnToQuoteClicked = useCallback(() => {
        returnToQuoteClicked = true;
        onNext();
    }, [onNext]);

    const showPriorCarrierMessage = () => {
        return !_.isEmpty(submissionVM.lobData.personalAuto.questionSets_ML.priorInsurance.readOnlyAnswers_Ext.value)
    };

    const showIMFWarning = () => {
        if (submissionVM?.imfWarnings?.value?.length > 0) {
            return true;
        }

        return false;
    };

    const nextStepText_Ext = () => {
        return <FormattedMessage
            {...messages.nextDescription}
            values={{
                review: (
                    <strong>{translator(messages.reviewForAnyDrivingActivity)}</strong>
                )
            }}
        />;
    };

    const overrides = {
        priorInsuranceComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors,
            syncQuestionSets: syncQuestionSets,
            showPriorInsuranceErrors,
            updateShowPriorInsuranceErrors: setShowPriorInsuranceErrors,
            showErrors,
            isGpa: true
        },
        imfWarningAlert: {
            visible: showIMFWarning(),
            message: showIMFWarning() && submissionVM?.imfWarnings?.value[0]
        },
        priorInsuranceInfoMessage: {
            visible: showPriorCarrierMessage(),
        },
        houseadditionalquestionset: {
            showHeaderML: false,
            labelPosition: 'top',
            model: submissionVM,
            onValidate: onValidate,
            onValueChange: syncQuestionSets
        },
        modifierComponent: {
            modifier: paModifiers.lineModifiers,
            updateModifier: updateModifier,
            isFieldDefaultedByHVQ: isFieldDefaultedByHVQ,
            onValidate: onValidate,
            showValidationErrors: showErrors,
            visible: !_.isUndefined(paModifiers),
            showPopover: false,
            submissionVM,
            updateWizardData,
            handleOnChange: true
        },
        driversListComponent: {
            paModel: paModel,
            refreshData,
            isPrimaryVehicleReqState: isPrimaryVehicleReqState,
            state: state,
            showErrors
        },
        excludedDriversComponentContainer: {
            visible: canExcludeDrivers
        },
        excludedDriversComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            validateNonRatedDrivers: validateNonRatedDrivers,
            clearErrors: clearErrorMessages,
            steps: steps,
            jumpTo: jumpTo,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            hideInsure: false,
            hideMaritalStatus: false,
            driverType: getExcludedDriverType(),
            messages: AddExcludedDriverPopup.excludedDriversMessages,
            addDriverPopupMetadata: AddExcludedDriverPopup.metadata,
            addDriverPopupModalBodyStyles: AddExcludedDriverPopup.styles,
            typedDrivers: excludedDrivers,
            setTypedDrivers: setExcludedDrivers
        },
        householdMembersComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            validateNonRatedDrivers: validateNonRatedDrivers,
            clearErrors: clearErrorMessages,
            steps: steps,
            jumpTo: jumpTo,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            hideInsure: false,
            hideMaritalStatus: true,
            driverType: getHouseholdDriverType(),
            messages: AddHouseholdMemberPopup.householdMessages,
            addDriverPopupMetadata: AddHouseholdMemberPopup.metadata,
            addDriverPopupModalBodyStyles: AddHouseholdMemberPopup.styles,
            typedDrivers: houseHoldDrivers,
            setTypedDrivers: setHouseHoldDrivers
        },
        nextDescription: {
            content: nextStepText_Ext(),
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext,
            showReturnToQuote
        },
        vehiclesListComponent: {
            visible: shouldShowVehicleListSection(),
            isVehiclePrimaryDriverState,
            isVehiclePrimaryDriverPercentageState,
            drivers: ratedDrivers,
            vehicles,
            vehicleDrivers: vehicleDriversVM,
            vehicleDriverErrors,
            setVehicleDriverErrors
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        }
    };

    const resolvers = {
        resolveComponentMap: {
            priorinsurancecomponent: PriorInsuranceComponent,
            driverslistcomponent: DriversListComponent,
            questionset: QuestionSetComponent,
            excludeddriverscomponent: DriversTableActionComponent,
            householdmemberscomponent: DriversTableActionComponent,
            vehicleslistcomponent: VehiclesListComponent,
            modifiercomponent: MLModifierComponent
        },
        resolveCallbackMap: {
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors,
            onUpdateDrivers: onUpdateDrivers,
            validateNonRatedDrivers: validateNonRatedDrivers,
            onNext: onNext
        }
    };

    const skipOnResumeIf = () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {
            // Temporary - only allow skipping for bound policies
            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paAddtlInfoToQuote') {
                console.log('Stopping on Additional Information Page becasue last visited step is paAddtlInfoToQuote');
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.isBundle_ML.value
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }

            if (submissionVM.lobData.personalAuto.questionSets_ML) {

                const highestLevelOfEducation = submissionVM.lobData.personalAuto.questionSets_ML.houseAdditionalInformation;
                if (!isModernProduct && _.isNil(highestLevelOfEducation.answers.value.PAHighestLevelOfEducation_ML)) {
                    console.log('Stopping on Additional Information Page becasue Highest Education is undefiend');
                    return false
                }

                // Check the most basic of priorinsurance questions.  In order to catch all invalid states, we'd need to reproduce the logic from the question set.
                const { priorInsurance } = submissionVM.lobData.personalAuto.questionSets_ML;
                if (priorInsurance && (!isModernProduct && priorInsurance.answers.value.InsuredPolicyLast90Days_ML === "false") && _.isNil(priorInsurance.answers.value.CurrentInsuranceProvider_ML)) {
                    console.log('Stopping on Additional Information Page becasue priorInsurance is invalid');
                    return false
                }

                if (submissionVM.lobData.personalAuto.questionSets_ML.aspects.valid !== true ||
                    submissionVM.lobData.personalAuto.questionSets_ML.aspects.subtreeValid !== true
                ) {
                    console.log('Stopping on Additional Information Page because questionSets are invalid');
                    return false;
                }

                if (_.isNull(priorInsurance.answers.value.CoverageLapseDueToMilitaryService_Ext)) {

                    return false
                }

                if (_.isNull(priorInsurance.answers.value.LengthWithCurrentCarrier_ML)) {

                    return false
                }

                if (validateAdditionInfoQuestions()) {

                    return false
                }

            }

            if (submissionVM.lobData.personalAuto.modifiers_ML && (
                submissionVM.lobData.personalAuto.modifiers_ML.aspects.valid !== true ||
                submissionVM.lobData.personalAuto.modifiers_ML.aspects.subtreeValid !== true
            )) {
                console.log('Stopping on Additional Information Page becasue modifiers are invalid');
                return false;
            }

            console.log('Skipping Additional Information Page becuase everything is valid');
            return true
        }
    };

    useEffect(() => {
        if (isGPA && (!isSkipping || (isSkipping && !skipOnResumeIf())) && !nextStepVisited()) {
            const multiPolicyPromise = LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
            showProgressDialog(platformMessages.syncing, multiPolicyPromise, true);

            multiPolicyPromise.then((submissionData) => {
                _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
                updateWizardData(submissionVM);
            })
        }
    }, []);

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
            onReturnToQuote={onReturnToQuoteClicked}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

AdditionalInformation.propTypes = wizardProps;
export default withRouter(AdditionalInformation);
